<template>
  <div class="relative mb-12" v-if="displayTip">
    <IconCross class="absolute text-red right-0 top-1
                      cursor-pointer transition duration-200 hover:text-red-hover"
               @click.native="hideTip"/>
    <div class="text-xl font-bold text-text leading-tight  mb-8">
      Подключайте банки и платежные системы!
    </div>
    <p class="text-md text-text-label leading-8 pr-15">
      Вы можете провести интеграцию с вашими банками и электронными платежными системами, чтобы автоматизировать внесение операций. После того, как вы в первый раз установите категории расходов, следующие расходы будут распределяться по категориям автоматически.
      <br> <br>
      MoneyKeeper имеет ограниченный доступ к информации по вашему счету и не может выполнять операции расхода или перевода.
      Оцените возможности и настройте систему под себя!
    </p>
  </div>
</template>

<script>
import IconCross from "@/components/icons/IconCross";

export default {
  name: "BanksIntegrationsTip",
  components: {IconCross},
  data() {
    return {
      displayTip: !+this.$cookies.get('hide-tip-banks-integrations')
    }
  },
  methods: {
    hideTip() {
      this.$cookies.set('hide-tip-banks-integrations', 1)
      this.displayTip = false;
    }
  }
}
</script>